import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "../axios";

export const postMyStyle = async (newMyStyle) => {
  const response = await axiosInstance.post(
    `/umbraco/api/personality/preview-personality/`,
    newMyStyle,
  );
  return response.data;
};

export const useMyStyle = () => {
  return useQuery({
    queryKey: ["my-style-widget"],
    queryFn: null,
    enabled: false,
  });
};
